import React, { useCallback, useEffect, useState } from "react";
import { errorMessage } from "../../services";
import { getPlans } from "../../services/admin";
import { getSites } from "../../services/sites";
import { money } from "../../utils/format";
import PayModal from "./PayModal";
import PaymentHistory from "./PaymentHistory";
import SiteTable from "./SiteTable";
import useSiteActions from "./useSiteActions";

// A store owner's plans, renewals and payments
export default function BillingTab({ user, notify }) {
  const [sites, setSites] = useState([]);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [version, setVersion] = useState(0);

  const load = useCallback(async () => {
    try {
      const { data } = await getSites({ limit: 100, sort: "expiry" });
      setSites(data.sites);
      setError("");
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { getPlans().then(({ data }) => setPlans(data.plans)).catch(() => setPlans([])); }, []);

  const reload = () => { load(); setVersion((v) => v + 1); };
  const actions = useSiteActions({ notify, reload });
  const monthly = plans.find((p) => p.key === "monthly");
  const trial = plans.find((p) => p.key === "trial");

  return (
    <>
      <div className="page-heading">
        <div>
          <p className="eyebrow">ACCOUNT SETTINGS</p>
          <h1>Billing & subscription</h1>
          <p className="subheading">Your website plans, renewals and payments.</p>
        </div>
      </div>
      {monthly && (
        <div className="panel info-panel">
          <h2>Website subscription</h2>
          <p>Plan price: <b>{money(monthly.price)} per month per website</b>{trial ? ` after a ${trial.trialDays}-day free trial` : ""}. A payment activates your plan once it has been confirmed.</p>
        </div>
      )}
      {error && <div className="admin-error tab-gap">{error}</div>}
      <div className="panel table-panel tab-gap">
        <div className="panel-heading"><div><h2>Your websites</h2><p>Renew before the expiry date to keep your store online.</p></div></div>
        <SiteTable sites={sites} user={user} loading={loading} onToggle={actions.toggle} onPay={actions.openPay} />
      </div>
      <PaymentHistory key={version} user={user} notify={notify} />
      {actions.payTarget && <PayModal site={actions.payTarget} isSuperAdmin={false} onSubmit={actions.pay} onClose={actions.closePay} />}
    </>
  );
}
